export const BCTransplantLink = () => {
return(
  <header className="mt-10 items-end pb-6">
    <a href="http://www.transplant.bc.ca/" target="_blank" rel="noreferrer" >
      <img
        src="/images/logo-bctransplant.png"
        alt="BC Transplant"
        className="mx-auto  mx-0 h-16 md:mr-2"
      />
    </a>
  </header>
  )
}
